
























































































import { genVuexComputeds } from '@/main/pages/editFactory';
import { printButton, previewButton } from '@/main/utils/tableOperations';
import { gdprTiskUrl } from '@/modules/kartoteka/partner/api';
import { openEdit } from '@/main/router/routerPath';
import { NAME } from '@/modules/kartoteka/partner/constants';
import { PageMode } from '@/main/utils/pageMode';
import { mapActionsDvm } from '@/main/pages';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { NAME as ZAKAZKA_PP } from '@/modules/servis/zakazka/pracovniPozice/constants';
import { Cell } from '@/main/utils/table';
import { getTableCount } from '@/main/utils/commonFunctions';

import { showAlert } from '@/main/utils/notifications';

import { PdfProvider } from '#services/pdfProvider';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { OdlozenaServisniCinnost } from './odlozeneServisniCinnosti';
import { CustomerFeedback } from './customerFeedback';
import Poznamky from './poznamky/Poznamky.vue';
import Zarazeni from './zarazeni/Zarazeni.vue';
import Historie from './historie/Historie.vue';
import FakturacniTexty from './FakturacniTexty.vue';
import Kalkulace from './Kalkulace.vue';
import Zalohy from './Zalohy.vue';
import Reference from './Reference.vue';
import Saga2 from './Saga2.vue';
import ReserveParts from './ReserveParts.vue';
import Saga2Komunikace from './Saga2Komunikace.vue';
import OZakazkaOtherInfoTable from './OtherInfo.vue';
import { NahradniDily } from '../nahradniDily';
import { PracovniPozice } from '../pracovniPozice';
import { ServiceJobDetails } from '../ServiceJobDetails';
import { CiziVykony } from '../ciziVykony';
import { Korekce } from '../korekce';
import { Vydejky } from './vydejky';
import { LogServisniZakazky } from './logServisniZakazky';
import { ZakazkyRef } from './zakazkyReferencni';
import { Zapujcky } from '../zapujcky';
import { Pneu } from '../pneu';
import { PlanSkutecnost } from './planSkutecnost';
import { DokladyOstatni } from './doklady';
import { ADDITIONAL_TAB_CLICK_HANDLE, TAB_NAMES, ZAKAZKA_ND, PRACOVNI_POZICE } from '../constants';
import { store } from '../store/edit';
import { AttachmentFiles } from './Attachment';
import { AdvancePay } from './AdvancePay';
import { apiProvider } from '../api';
import HealthCard from './healthCard/HealthCard.vue';

export default EditStoreMixin.extend({
	name: 'ZakazkaTabs',
	components: {
		Poznamky,
		FakturacniTexty,
		Zarazeni,
		Kalkulace,
		Zalohy,
		Historie,
		Reference,
		ReserveParts,
		Saga2,
		Saga2Komunikace,
		OZakazkaOtherInfoTable,
		NahradniDily: NahradniDily.components.Card,
		PracovniPozice: PracovniPozice.components.Card,
		ServiceJobDetails: ServiceJobDetails.components.Card,
		CiziVykony: CiziVykony.components.Card,
		SlevyKorekce: Korekce.components.Card,
		Vydejky: Vydejky.components.Card,
		LogServisniZakazky: LogServisniZakazky.components.Card,
		ZakazkyRef: ZakazkyRef.components.Card,
		Zapujcky: Zapujcky.components.Card,
		Pneu: Pneu.components.Card,
		OdlozenaServisniCinnost: OdlozenaServisniCinnost.components.Card,
		PlanSkutecnost: PlanSkutecnost.components.Card,
		DokladyOstatni: DokladyOstatni.components.Card,
		AttachmentFiles: AttachmentFiles.components.Card,
		AdvancePay: AdvancePay.components.Card,
		CustomerFeedback: CustomerFeedback.components.Card,
		DmsPdfDialog,
		HealthCard,
	},
	props: {
		items: { type: Object, required: true },
	},
	data() {
		return {
			tabNames: TAB_NAMES,
			zpracovosDatId: null as number | null,
			showTiskDialog: false,
			printButton,
			previewButton,
			gdprTiskUrl,
		};
	},
	computed: {
		...genVuexComputeds(store),
		gdprTiskFilter(): { Id: number; PrintDialog: boolean; ReportType: string; ZpracovostdatId: number | null } {
			return {
				Id: this.ZakaznikId!,
				PrintDialog: true,
				ReportType: 'pdf',
				ZpracovostdatId: this.zpracovosDatId,
			};
		},
		finalAdvancePayCount(): number {
			return getTableCount(this.dependentTables?.AdvancePay, this.AdvancePaymentCount);
		},
		finalPartsCount(): number {
			return getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount);
		},
		finalLaborsCount(): number {
			return getTableCount(this.dependentTables?.ZakazkaPracovniPozice, this.LaborsCount);
		},
		finalExtLaborCount(): number {
			return getTableCount(this.dependentTables?.ZakazkaCiziVykony, this.ExtLaborCount);
		},
		finalDiscountCount(): number {
			return getTableCount(this.dependentTables?.ZakazkaKorekce, this.DiscountCount);
		},
		finalHistoryCount(): number {
			return getTableCount(this.dependentTables?.ZakazkaControl, this.HistoryCount);
		},
		finalSaga2Count(): number {
			return getTableCount(this.dependentTables?.Saga2Hlav, this.Saga2Count);
		},
		finalSaga2PolCount(): number {
			return getTableCount(this.dependentTables?.Saga2Pol, this.Saga2PolCount);
		},
		finalSaga2CommunicationsCount(): number {
			return getTableCount(this.dependentTables?.Saga2Komunikace, this.Saga2CommunicationsCount);
		},
		finalNonGenuineAttachmentFilesCount(): number {
			return getTableCount(this.dependentTables?.NonGenuineAttachmentFiles, this.NonGenuineAttachementFilesCount);
		},
		finalAttachmentFilesCount(): number {
			return getTableCount(this.dependentTables?.AttachmentFiles, this.AttachmentFilesCount);
		},
		finalInvoicesCount(): number {
			return getTableCount(this.dependentTables?.DokladOstatni, this.InvoicesCount);
		},
		finalReserveFormCount(): number {
			return getTableCount(this.dependentTables?.ReserveParts, this.ReserveFormCount);
		},
		tabSufix(): Record<string, string> {
			return {
				[TAB_NAMES.ADVANCEPAY]: `${this.finalAdvancePayCount}`,
				[TAB_NAMES.PRAC]: `${this.finalPartsCount}/${this.finalLaborsCount}`,
				[TAB_NAMES.ND]: `${this.finalPartsCount}`,
				[TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE]: `${this.finalExtLaborCount}/${this.finalDiscountCount}`,
				[TAB_NAMES.ZALOHY]: `${this.dependentTables.ZakazkaZaloha.rows.length}`,
				[TAB_NAMES.VYDEJKY]: `${this.dependentTables.Vydejka.rows.length}`,
				[TAB_NAMES.HISTORY]: `${this.finalHistoryCount}`,
				[TAB_NAMES.ZAKAZKY_REF]: `${this.dependentTables.RefTable.rows.length}`,
				[TAB_NAMES.GDPR]: `${this.dependentTables.GDPR.rows.length}`,
				[TAB_NAMES.ZAPUJCKY_REF]: `${this.dependentTables.ZakazkaZapujcka.rows.length}/${this.dependentTables.ZakazkaPneu.rows.length}`,
				[TAB_NAMES.SAGA_2]: `${this.finalSaga2Count}/${this.finalSaga2PolCount}`,
				[TAB_NAMES.SAGA_2_KOMUNIKACE]: `${this.finalSaga2CommunicationsCount}`,
				[TAB_NAMES.PLAN_SKUTECNOST]: `${this.dependentTables.PlanSkut.rows.length}`,
				[TAB_NAMES.DOKLAD]: `${this.finalNonGenuineAttachmentFilesCount}/${this.finalAttachmentFilesCount}/${this.finalInvoicesCount}`,
				[TAB_NAMES.PARTS_RESERVE]: `${this.finalReserveFormCount}`,
				[TAB_NAMES.ZAKAZKY_OSC]: `${this.dependentTables.OdlozenaServisniCinnost.rows.length}`,
				[TAB_NAMES.CUSTOMER_FEEDBACK]: `${this.dependentTables.CustomerFeedback.rows.length}`,
				[TAB_NAMES.HEALTH_CARD]: `${this.dependentTables.CustomerFeedback.rows.length}`,
			};
		},
	},
	mounted() {
		if (!this.dmsSys.CustomerFeedbackPrp) delete this.items.CustomerFeedback;
		if (!this.dmsSys.HealthCardPrp) delete this.items.HEALTH_CARD;
	},
	methods: {
		...mapActionsDvm(store.actions),
		tabClicked(tab: any) {
			if (ADDITIONAL_TAB_CLICK_HANDLE.includes(tab.$props.name)) {
				this.$emit('tab-click', tab);
			}
		},
		async gdprPrint(e: Event, cells: Cell[]) {
			[this.zpracovosDatId] = cells;
			const pdfProvider = new PdfProvider(gdprTiskUrl);
			await pdfProvider.fetch(this.gdprTiskFilter);
			pdfProvider.print();
		},
		gdprPreview(e: Event, cells: Cell[]) {
			[this.zpracovosDatId] = cells;
			this.showTiskDialog = true;
		},
		openZakaznik() {
			return openEdit(NAME, this.CanEditZakaznik ? PageMode.EDIT : PageMode.VIEW, { id: this.ZakaznikId! });
		},
		create() {
			this.$emit('create-zaloha');
		},
		async deleteRowClick(data: { name: string, data: Record<string, any> }) {
			if (data.data.IS_LOCKED && this.dmsSys.IsCancelInvoicePrp) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemIsLocked'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (this.dmsSys.ServicePackagePrp) {
				if (data.name === PRACOVNI_POZICE && data.data.SERVICE_PACKAGE_ID) {
					showAlert({
						message: this.LocalizeChyboveHlasky('SERVICE_PACKAGE_DELETE'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				if (data.name === ZAKAZKA_ND && data.data.SERVICE_PACKAGE_ID) {
					showAlert({
						message: this.LocalizeChyboveHlasky('SERVICE_PACKAGE_DELETE'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
			}
			if (this.dmsSys.IsActivityEndTimePrp) {
				if (data.data.ACTIVITY_END_TIME! && data.name === PRACOVNI_POZICE)	{
					this.showErrorAlert({ message: 'ItemCannotDelete' });
					return;
				}
				if (data.data.LINE_ITEM_STATUS_ID! && data.name === ZAKAZKA_ND)	{
					this.showErrorAlert({ message: 'ItemCannotDelete' });
					return;
				}
			}
			if (data.name === ZAKAZKA_ND) {
				this.getPaketyCount();
			}
			this.$emit('delete-click', data);
			if (this.dmsSys.WorkItemPrp) {
				if ([ZAKAZKA_ND, ZAKAZKA_PP].includes(data.name)) {
					const { data: status } = await apiProvider.getWorkCompletionStatus({ zakazkaId: this.ZakazkaId! });
					this.IsAllItemLevelStatusEntered = status;
					if (this.IsAllItemLevelStatusEntered) {
						await apiProvider.sendWorkNotification({ zakaznikId: this.ZakaznikId!, zakazkaNr: this.ZakazkaNr });
					}
				}
			}
		},
	},
});
